export default [
  {
    title: '定向ID',
    key: 'targetingId',
    width: 72,
    fixed: true,
    type: 'basic'
  },
  {
    title: '定向名称',
    key: 'targetingName',
    width: 140,
    fixed: true,
    type: 'basic'
  },
  {
    title: '定向描述',
    key: 'targetingDesc',
    width: 140,
    overflow: true,
    type: 'basic'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 82,
    type: 'basic'
  },
  {
    title: '关联计划数',
    key: 'associatedPlans',
    width: 88,
    type: 'basic'
  },
  {
    title: '曝光量',
    key: 'pv',
    width: 82,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击量',
    key: 'clickNum',
    width: 82,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: 82,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗',
    key: 'amount',
    width: 96,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    width: 82,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    width: 96,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费成本',
    key: 'payCost',
    width: 96,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'activeRate',
    width: 82,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '创角付费数',
    key: 'payRoleUserNum',
    width: 108,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '首日创角付费率',
    key: 'payRoleUserRate',
    width: 130,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '首日ROI',
    key: 'oneDayRoi',
    width: 94,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '3日ROI',
    key: 'threeDayRoi',
    width: 94,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '7日ROI',
    key: 'sevenDayRoi',
    width: 94,
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '创建人',
    key: 'createOpName',
    width: 90,
    type: 'basic'
  },
  {
    title: '更新人',
    key: 'updateOpName',
    width: 90,
    type: 'basic'
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 140,
    type: 'basic'
  },
  {
    title: '操作',
    key: 'control',
    width: 123,
    fixed: true,
    type: 'basic'
  }
]
